import React, { Suspense, lazy } from 'react';
import Banner from '../../components/banners/about';
import Testimonial from '../../components/content/testimonial';
//import Team from '../../components/content/team';
import Career from '../../components/content/career';
//import Media from '../../components/content/media';
import classes from './style.module.scss';
import { Helmet } from 'react-helmet';

const Team = lazy(() => import('../../components/content/team'));
const Media = lazy(() => import('../../components/content/media'));

export const About = () => {
  return (
    <div className={classes.MainContent}>
      <Helmet>
        <meta charSet='utf-8' />
        <title>About | React Poland</title>
        <meta property='og:title' content='About | React Poland' />
        <meta
          name='description'
          content='ReactJS is a JavaScript library for building user interfaces.
It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications.'
        />
        <meta
          property='og:description'
          content='The React Poland is a focused web and mobile applications development company located in Poland. The company was founded in 2014, and all our past and current projects use ReactJS or React-Native. No compromises here, React is our main focus.'
        />
        <meta
          property='og:image'
          content='https://uploads-ssl.webflow.com/5cc2e264e18ab81050275c14/5d0365ce5349348eba96023c_image.png'
        />
        <meta property='og:url' content='www.reactpoland.com/about/' />
      </Helmet>
      <Banner />
      <Suspense fallback={<div>Loading...</div>}>
        <Team />
        <Career />
        <Testimonial />
        <Media />
      </Suspense>
    </div>
  );
};

export default About;
